import styled from "@emotion/styled";
import { HistoryTimelineProps } from "./HistoryTimeline";
import { Tooltip } from "@mui/material";
import AIcon2 from "@icons-rf/timeline/Aicon2.svg?react";
import Alert from "@icons-rf/timeline/alertIcon.svg?react";
import MxFormSubTitleAndDescription from "@rf-l1/page/form/MxFormSubTitleAndDescription";

const HistoryTimeLineHeader = () => {
  const Dots = [
    { id: 1, status: "Ruta crítica", color: "#B22B2E" },
    { id: 2, status: "Si aplica", color: "#007DC3" },
    { id: 3, status: "Puntos de verificación", color: "#1A3668" },
    { id: 4, status: "Tiempo de transición entre hitos", color: "#404041" }
  ];

  return (
    <>
      <MxFormSubTitleAndDescription
        isRequired={false}
        label="Línea de tiempo de validación de proyecto"
        description="Seleccione uno de los ítems para visualizar su descripción"
      />

      {Dots.map((item, index) => (
        <DescriptionCDots key={index}>
          <Dot color={item.color} />

          {[1].includes(item.id) && (
            <Tooltip title="Detiene comercialización" placement="top" arrow>
              <Wrapper color="#b22b2e">
                <Alert />
              </Wrapper>
            </Tooltip>
          )}

          {[2].includes(item.id) && (
            <Tooltip title="Si aplica" placement="top" arrow>
              <div style={{ display: "flex", alignItems: "center" }}>
                <AIcon2 />
              </div>
            </Tooltip>
          )}

          <Text>{item.status}</Text>
        </DescriptionCDots>
      ))}
    </>
  );
};

export default HistoryTimeLineHeader;

const DescriptionCDots = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.3rem;
  margin: 0.8rem 0rem;
  padding-right: 1rem;
`;

const Dot = styled.div<HistoryTimelineProps>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

const Wrapper = styled("span")<{ color: string }>`
  display: flex;
  align-items: center;
  font-size: 13px;

  svg {
    stroke: ${({ color }) => color};
  }
`;

const Text = styled("p")`
  font-size: 12px;
  color: #1a3668;
  font-weight: 500;
`;
